<script>
import { mapState } from "vuex";

export default {
	name: "umatPerLingkungan",
	components: {},
	data() {
		return {
			info: {},
			loading: true,
		};
	},
	created() {
		this.findAll();
	},
	mounted() {},
	computed: {
		...mapState({
			myData: (state) => state.laporan.data,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
	},
	methods: {
		async findAll() {
			await this.$store.dispatch("laporan/getJumlahUmat");
		},
		refreshData() {
			this.findAll();
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Laporan Jumlah Umat/KK" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refresh"
									>
										<div
											v-show="isLoading"
											class="
												spinner-border spinner-border-sm
												text-light
											"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<!-- --------------------------- /FILTER --------------------------- -->

				<div class="card-body">
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<div class="table-responsive invoice-table">
							<table class="table table-bordered table-striped">
								<thead class="thead-light">
									<tr>
										<th class="text-center">NO.</th>
										<th class="text-center">NAMA</th>
										<th class="text-right">LAKI-LAKI</th>
										<th class="text-right">PEREMPUAN</th>
										<th class="text-right">TOTAL JIWA</th>
										<th class="text-right">TOTAL KK</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="item in myData.items" :key="item.id">
										<td class="text-center">{{ item.no }}</td>
										<td>{{ item.nama }}</td>
										<td class="text-right">{{ item.l }}</td>
										<td class="text-right">{{ item.p }}</td>
										<td class="text-right">{{ item.total }}</td>
										<td class="text-right">{{ item.kk }}</td>
									</tr>
								</tbody>
								<tfoot class="thead-dark">
									<tr>
										<td class="text-center" colspan="2">TOTAL</td>
										<td class="text-right">{{ myData.total.l }}</td>
										<td class="text-right">{{ myData.total.p }}</td>
										<td class="text-right">
											{{ myData.total.total }}
										</td>
										<td class="text-right">{{ myData.total.kk }}</td>
									</tr>
								</tfoot>
							</table>
						</div>
                  <p>Filter Data :                  
                  <ol>
                  <li>Masih hidup</li>
                  <li>Beragama Katolik</li>
                  <li>berada di lingkungan/stasi Paroki Katedral Kristus Raja Sintang</li>
                  </ol>
                  </p>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.table tfoot {
	background-color: #212529;
}
.table tfoot td {
	color: #fff;
}

.table {
	font-size: 12px !important;
}

.table th,
.table td {
	padding: 0.5rem;
}
</style>